
import { getDateDataFromDateCode } from "@utils";
import { PAGES } from "@consts";

export default {
	name: "AnswerSection",
	props: {
		apiData: {
			required: true,
			type: Object,
		},
		headerElement: {
			type: String,
			default: "h2",
			validator: (val) => /^h\d{1}$/.test(val),
		},
	},
	data() {
		return {
			showAnswer: false,
		};
	},
	computed: {
		answerHeading() {
			if (!this.apiData) {
				return null;
			}

			const isYesterday =
				this.$route.name === PAGES.WORDLE_YESTERDAY_HINTS;

			const date = getDateDataFromDateCode(this.apiData.date);
			const dateString = `${date.month}&nbsp;${date.day},&nbsp;${date.year}`;

			return `${
				isYesterday ? "Yesterday’s" : "Today’s"
			}&nbsp;Wordle&nbsp;Answer&nbsp;(#${
				this.apiData.index
			}) ${dateString}`;
		},
	},
};
